<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <ng-container formGroupName="riskProfil">
                @if (display(owner?.get('riskProfil'), 'knowMonetaryProduct')) {
                  <div class="section-investment">
                    <title direction="left" class="section-title">
                      Fonds monétaires, Livrets, Fonds Euro
                    </title>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-12">
                          <title class="section-quest-title" direction="left">
                            A moyen long terme, les produits monétaires offrent
                            une espérance de rendement inférieure à celle de
                            certains actifs risqués
                          </title>
                        </div>
                        <div class="col col-md-12">
                          <pr-input-radio
                            formControlName="monetaryProduct"
                            direction="column"
                            [isDefault]="false"
                            [toggle]="true"
                            [options]="options"
                            [columns]="3"
                          >
                          </pr-input-radio>
                        </div>
                      </div>
                    </div>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-6 bloc-invest">
                          <p class="label-invest">Avez-vous déjà investi ?</p>
                          <pr-input-radio
                            formControlName="investMonetaryProduct"
                            direction="column"
                            [isDefault]="false"
                            columns="2"
                            [options]="options1"
                            [derrors]="derrors"
                          >
                          </pr-input-radio>
                        </div>
                        @if (
                          display(
                            owner?.get('riskProfil'),
                            'investMonetaryProduct'
                          )
                        ) {
                          <div class="col col-md-6">
                            <pr-input-column
                              label="Type de gestion"
                              [derrors]="derrors"
                            >
                              <mat-select
                                formControlName="monetaryProductManagementMode"
                              >
                                @for (
                                  option of optionsManagementMode;
                                  track option
                                ) {
                                  <mat-option [value]="option.value">
                                    {{ option.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </pr-input-column>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (display(owner?.get('riskProfil'), 'knowBond')) {
                  <div class="section-investment">
                    <title direction="left" class="section-title">
                      Obligations
                    </title>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-12">
                          <title class="section-quest-title" direction="left">
                            Si les taux d'intérêt augmentent, le prix des
                            obligations évoluent à la baisse ?
                          </title>
                        </div>
                        <div class="col col-md-12">
                          <pr-input-radio
                            formControlName="bond"
                            direction="column"
                            [isDefault]="false"
                            [toggle]="true"
                            [options]="options"
                            [columns]="3"
                          >
                          </pr-input-radio>
                        </div>
                      </div>
                    </div>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-6 bloc-invest">
                          <p class="label-invest">Avez-vous déjà investi ?</p>
                          <pr-input-radio
                            formControlName="investBond"
                            direction="column"
                            [isDefault]="false"
                            columns="2"
                            [options]="options1"
                            [derrors]="derrors"
                          >
                          </pr-input-radio>
                        </div>
                        @if (display(owner?.get('riskProfil'), 'investBond')) {
                          <div class="col col-md-6">
                            <pr-input-column
                              label="Type de gestion"
                              [derrors]="derrors"
                            >
                              <mat-select formControlName="bondManagementMode">
                                @for (
                                  option of optionsManagementMode;
                                  track option
                                ) {
                                  <mat-option [value]="option.value">
                                    {{ option.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </pr-input-column>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (display(owner?.get('riskProfil'), 'knowStock')) {
                  <div class="section-investment">
                    <title direction="left" class="section-title">
                      Actions sur le marché boursier
                    </title>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-12">
                          <title class="section-quest-title" direction="left">
                            Détenir une action correspond à détenir une dette
                            d’une entreprise ?
                          </title>
                        </div>
                        <div class="col col-md-12">
                          <pr-input-radio
                            formControlName="stock"
                            direction="column"
                            [isDefault]="false"
                            [toggle]="true"
                            [options]="options"
                            [columns]="3"
                          >
                          </pr-input-radio>
                        </div>
                      </div>
                    </div>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-6 bloc-invest">
                          <p class="label-invest">Avez-vous déjà investi ?</p>
                          <pr-input-radio
                            formControlName="investStock"
                            direction="column"
                            [isDefault]="false"
                            columns="2"
                            [options]="options1"
                            [derrors]="derrors"
                          >
                          </pr-input-radio>
                        </div>
                        @if (display(owner?.get('riskProfil'), 'investStock')) {
                          <div class="col col-md-6">
                            <pr-input-column
                              label="Type de gestion"
                              [derrors]="derrors"
                            >
                              <mat-select formControlName="stockManagementMode">
                                @for (
                                  option of optionsManagementMode;
                                  track option
                                ) {
                                  <mat-option [value]="option.value">
                                    {{ option.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </pr-input-column>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (display(owner?.get('riskProfil'), 'knowScpi')) {
                  <div class="section-investment">
                    <title direction="left" class="section-title">SCPI</title>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-12">
                          <title class="section-quest-title" direction="left">
                            L'investissement en parts de SCPI offre une garantie
                            en capital ?
                          </title>
                        </div>
                        <div class="col col-md-12">
                          <pr-input-radio
                            formControlName="scpi"
                            direction="column"
                            [isDefault]="false"
                            [toggle]="true"
                            [options]="options"
                            [columns]="3"
                          >
                          </pr-input-radio>
                        </div>
                      </div>
                    </div>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-6 bloc-invest">
                          <p class="label-invest">Avez-vous déjà investi ?</p>
                          <pr-input-radio
                            formControlName="investScpi"
                            direction="column"
                            [isDefault]="false"
                            columns="2"
                            [options]="options1"
                            [derrors]="derrors"
                          >
                          </pr-input-radio>
                        </div>
                        @if (display(owner?.get('riskProfil'), 'investScpi')) {
                          <div class="col col-md-6">
                            <pr-input-column
                              label="Type de gestion"
                              [derrors]="derrors"
                            >
                              <mat-select formControlName="scpiManagementMode">
                                @for (
                                  option of optionsManagementMode;
                                  track option
                                ) {
                                  <mat-option [value]="option.value">
                                    {{ option.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </pr-input-column>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (display(owner?.get('riskProfil'), 'knowPrivateEquity')) {
                  <div class="section-investment">
                    <title direction="left" class="section-title">
                      Capital investissement
                    </title>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-12">
                          <title class="section-quest-title" direction="left">
                            Les principales caractéristiques des parts de FCPI /
                            FCPR sont une possibilité de forte rentabilité, un
                            risque élevé et une faible liquidité ?
                          </title>
                        </div>
                        <div class="col col-md-12">
                          <pr-input-radio
                            formControlName="privateEquity"
                            direction="column"
                            [isDefault]="false"
                            [toggle]="true"
                            [options]="options"
                            [columns]="3"
                          >
                          </pr-input-radio>
                        </div>
                      </div>
                    </div>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-6 bloc-invest">
                          <p class="label-invest">Avez-vous déjà investi ?</p>
                          <pr-input-radio
                            formControlName="investPrivateEquity"
                            direction="column"
                            [isDefault]="false"
                            columns="2"
                            [options]="options1"
                            [derrors]="derrors"
                          >
                          </pr-input-radio>
                        </div>
                        @if (
                          display(
                            owner?.get('riskProfil'),
                            'investPrivateEquity'
                          )
                        ) {
                          <div class="col col-md-6">
                            <pr-input-column
                              label="Type de gestion"
                              [derrors]="derrors"
                            >
                              <mat-select
                                formControlName="privateEquityManagementMode"
                              >
                                @for (
                                  option of optionsManagementMode;
                                  track option
                                ) {
                                  <mat-option [value]="option.value">
                                    {{ option.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </pr-input-column>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (display(owner?.get('riskProfil'), 'knowLifeInsurance')) {
                  <div class="section-investment">
                    <title direction="left" class="section-title">
                      Assurance Vie / PER
                    </title>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-12">
                          <title class="section-quest-title" direction="left">
                            L’assurance vie ne comporte aucun risque de perte
                            sur le long terme ?
                          </title>
                        </div>
                        <div class="col col-md-12">
                          <pr-input-radio
                            formControlName="lifeInsurance"
                            direction="column"
                            [isDefault]="false"
                            [toggle]="true"
                            [options]="options"
                            [columns]="3"
                          >
                          </pr-input-radio>
                        </div>
                      </div>
                    </div>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-6 bloc-invest">
                          <p class="label-invest">Avez-vous déjà investi ?</p>
                          <pr-input-radio
                            formControlName="investLifeInsurance"
                            direction="column"
                            [isDefault]="false"
                            columns="2"
                            [options]="options1"
                            [derrors]="derrors"
                          >
                          </pr-input-radio>
                        </div>
                        @if (
                          display(
                            owner?.get('riskProfil'),
                            'investLifeInsurance'
                          )
                        ) {
                          <div class="col col-md-6">
                            <pr-input-column
                              label="Type de gestion"
                              [derrors]="derrors"
                            >
                              <mat-select
                                formControlName="lifeInsuranceManagementMode"
                              >
                                @for (
                                  option of optionsManagementMode;
                                  track option
                                ) {
                                  <mat-option [value]="option.value">
                                    {{ option.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </pr-input-column>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if (
                  display(owner?.get('riskProfil'), 'knowDerivativeProducts')
                ) {
                  <div class="section-investment">
                    <title direction="left" class="section-title">
                      Produits financiers complexes, Instruments financiers
                      dérivés, ETF, Produits structurés
                    </title>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-12">
                          <title class="section-quest-title" direction="left">
                            Un ETF est un panier de titres qui se négocient en
                            bourse, comme une action ?
                          </title>
                        </div>
                        <div class="col col-md-12">
                          <pr-input-radio
                            formControlName="derivativeProducts"
                            direction="column"
                            [isDefault]="false"
                            [toggle]="true"
                            [options]="options"
                            [columns]="3"
                          >
                          </pr-input-radio>
                        </div>
                      </div>
                    </div>
                    <div class="formControl mt">
                      <div class="row">
                        <div class="col col-md-6 bloc-invest">
                          <p class="label-invest">Avez-vous déjà investi ?</p>
                          <pr-input-radio
                            formControlName="investDerivativeProducts"
                            direction="column"
                            [isDefault]="false"
                            columns="2"
                            [options]="options1"
                            [derrors]="derrors"
                          >
                          </pr-input-radio>
                        </div>
                        @if (
                          display(
                            owner?.get('riskProfil'),
                            'investDerivativeProducts'
                          )
                        ) {
                          <div class="col col-md-6">
                            <pr-input-column
                              label="Type de gestion"
                              [derrors]="derrors"
                            >
                              <mat-select
                                formControlName="derivativeProductsManagementMode"
                              >
                                @for (
                                  option of optionsManagementMode;
                                  track option
                                ) {
                                  <mat-option [value]="option.value">
                                    {{ option.label }}
                                  </mat-option>
                                }
                              </mat-select>
                            </pr-input-column>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </ng-container>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
